import { Modal } from './Modal';

export type { ModalProps, TypeModal } from './types';
export default Modal;
